const INK = "#0A0F0E";
const RULE = "#E0E3DE";

/*
 * Austrian universities, public, FH and private, as a slow band of logos under
 * the hero. Logos are self-hosted in /public/unilogos (the CSP blocks external
 * images). They rest in grey so the band reads as one calm line and show
 * their real colours under the cursor.
 *
 * `h` is the logo height in px, set by eye so every mark looks about the same
 * size: wide wordmarks get less height, square marks more.
 */
const UNIS: { name: string; file: string; h: number }[] = [
  { name: "Universität Wien", file: "uni-wien.svg", h: 34 },
  { name: "TU Wien", file: "tu-wien.svg", h: 40 },
  { name: "WU Wien", file: "wu-wien.svg", h: 40 },
  { name: "Universität Graz", file: "uni-graz.svg", h: 44 },
  { name: "Universität Innsbruck", file: "uni-innsbruck.svg", h: 38 },
  { name: "MedUni Wien", file: "meduni-wien.svg", h: 32 },
  { name: "JKU Linz", file: "jku.svg", h: 40 },
  { name: "TU Graz", file: "tu-graz.svg", h: 36 },
  { name: "Universität Salzburg", file: "uni-salzburg.svg", h: 36 },
  { name: "BOKU Wien", file: "boku.svg", h: 40 },
  { name: "Modul University Vienna", file: "modul.svg", h: 40 },
  { name: "Universität Klagenfurt", file: "uni-klagenfurt.svg", h: 36 },
  { name: "Montanuniversität Leoben", file: "leoben.svg", h: 30 },
  { name: "FH Technikum Wien", file: "fh-technikum-wien.svg", h: 44 },
  { name: "MCI Innsbruck", file: "mci.svg", h: 40 },
  { name: "Webster Vienna Private University", file: "webster-vienna.svg", h: 48 },
  { name: "Mozarteum Salzburg", file: "mozarteum.svg", h: 44 },
  { name: "mdw Wien", file: "mdw.svg", h: 48 },
  { name: "Kunstuniversität Graz", file: "kunstuni-graz.svg", h: 46 },
];

function Row({ hidden = false }: { hidden?: boolean }) {
  return (
    <ul className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {UNIS.map((u) => (
        <li key={u.file} className="flex h-16 items-center px-7 sm:px-9">
          <img
            src={`/unilogos/${u.file}`}
            alt={hidden ? "" : u.name}
            title={u.name}
            loading="lazy"
            decoding="async"
            className="w-auto max-w-[180px] object-contain opacity-65 grayscale transition-[filter,opacity,transform] duration-300 hover:-translate-y-0.5 hover:opacity-100 hover:grayscale-0"
            style={{ height: u.h }}
          />
        </li>
      ))}
    </ul>
  );
}

/**
 * A band under the hero: the universities a plan can lead to. Pauses under the
 * cursor; with reduced motion it simply stands still.
 */
export function UniversityMarquee() {
  return (
    <section aria-labelledby="unis-label" className="relative overflow-hidden border-y bg-white py-7" style={{ borderColor: RULE }}>
      <p id="unis-label" className="px-5 text-center text-[13px] font-bold uppercase tracking-[0.12em]" style={{ color: INK }}>
        Plans for every university in Austria
      </p>
      <div className="relative mt-4">
        <div className="flex w-max animate-[marquee_70s_linear_infinite] hover:[animation-play-state:paused]">
          <Row />
          <Row hidden />
        </div>
        {/* Soft fade at both ends. */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{ background: "linear-gradient(90deg, #fff 0%, rgba(255,255,255,0) 10%, rgba(255,255,255,0) 90%, #fff 100%)" }}
        />
      </div>
    </section>
  );
}
